import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'leads',
  async getComponent (nextState) {
    const {
      default: LeadsContainer
    } = await import(/* webpackChunkName: "leads-container" */ './LeadsContainer')
      .catch(handleChunkLoadError);
    return LeadsContainer;
  },
  getData: ({ context: { props } }) => props || {},
  children: [
    {
      path: '',
      async getComponent (nextState) {
        const {
          default: LeadsPage
        } = await import(/* webpackChunkName: "leads-page" */ './LeadsPage.tsx')
          .catch(handleChunkLoadError);
        return LeadsPage;
      },
      getData: ({ context: { props } }) => props || {}
    },
    {
      path: 'guide',
      async getComponent (nextState) {
        const {
          default: LeadsGuide
        } = await import(/* webpackChunkName: "leads-page" */ './LeadsGuide.tsx')
          .catch(handleChunkLoadError);
        return LeadsGuide;
      }
    }
  ]
});
